import React from "react"
import PropTypes from "prop-types"
import _ from 'lodash';
import { compose } from 'redux'
import Queue from "@material-ui/icons/Queue";
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { connect } from 'react-redux'
import { renderSnackbar } from 'actions/snackbar'
import api from "api"
import style from "assets/css/style.jsx"
import withStyles from '@material-ui/core/styles/withStyles'
import {FieldGroup, FormBuilder} from "react-reactive-form";
import Paper from "@material-ui/core/Paper";
import UploadGenericHighlightComponent from "../Components/upload-generic-highlight.component";
import UploadGenericSelloutComponent from '../Components/upload-generic-sellout.component';
import UploadGenericReceiptComponent from "../Components/upload-generic-receipt.component";
import { toast } from 'react-toastify';
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = require(`../../assets/css/style.jsx`).default;

class RequestForm extends React.Component {
  loginForm = FormBuilder.group({});

  state = {
    alert: null,
    loadingFile: false,
    ope_products: [],
    edited: false,
    requests: [
      {
        products: [{product: ""}]
      }
    ],
    tickets:[],
    urlImages:[],
    nameImages:[],
    form_errors: [],
    err:"",
    filterOperationLabel:[],
    requireOperation:[]
  };

  componentWillMount() {
    const match = this.props.match_params;
    const part_id = match.part_id;
    const data = this.props.data;

      this.getOperationLabel();


    if (undefined !== data &&  data.operation.needIban && data.user.cachedIban === '') {
      this.props.history.push('/mon-profil')
      this.props.renderSnackbar({
        color: 'warning',
        message: 'Veuillez renseigner vos coordonnées bancaires avant de participer à cette offre.'
      })
    }
  }

  getOperationLabel() {

      api.operations.operation_label()
        .then(resp => {
            let labelType;
          let location = this.props.history.location.state.type ? this.props.history.location.state.type : this.props.history.location.state;
          switch(location) {
            case 'Operation':
              labelType = "classic";
              break;
            case 'LocalOperation':
              labelType = "local";
              break;
            case 'CoopOperation':
              labelType = "coopoperation";
              break;
            default:
          }
          const filterOperationLabel = _.filter(resp.data['hydra:member'], { operationType: labelType, isActive:true });
            const requireOperation = filterOperationLabel.map((required) => ({isRequired:required.isRequired,labelType: labelType}));
            this.setState({filterOperationLabel:filterOperationLabel,requireOperation:requireOperation})
          this.loginForm.updateValueAndValidity();
        })
        .catch(error => {
        })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let arrayValidatorLength = [];
    this.state.filterOperationLabel.map((number) => {
      if (number.isRequired) {
        if (number) {
          const isBelowThreshold = (currentValue) => currentValue > 0;
          const array1 = [this.loginForm.get([number.labelType]).value.length ];
          arrayValidatorLength.push(array1.every(isBelowThreshold))
        }

      }
    });
    if(!arrayValidatorLength.includes(false)){
        if(this.props.match_params.part_id !== null) {
            this.props.history.push({
                pathname: `/recap-participation/${this.props.match_params.ope_id}`,
                state: { participation: '/api/operations/'+ this.props.match_params.ope_id, nameImage:this.state.urlImages, operation:this.props.data , type:this.props.history.location.state, urlImage:this.loginForm.value, opId:this.props.match_params.part_id }
            })
        }
        else{
            this.props.history.push({
                pathname: `/recap-participation/${this.props.match_params.ope_id}`,
                state: { participation: '/api/operations/'+ this.props.match_params.ope_id, nameImage:this.state.urlImages, operation:this.props.data , type:this.props.history.location.state, urlImage:this.loginForm.value, opId:0 }
            })
        }
    }
    else{
      toast.error("Vous n'avez pas téléchargez tout les fichiers")
    }
  };

  setRequestStateByIndex = (index, value) => {
    let requests  = this.state.requests.slice()
    requests.splice(index, 1, {...requests[index], ...value})

    this.setState({
      requests: requests
    })
  };

  renderBtn(invalid) {
    let notBlock = null;
    let block = null;
    if (invalid) {
      notBlock = (
          <Button
              style={{
                opacity: '0.4',
                backgroundColor: '#f50082',
                padding: '10px',
                color: 'white',
                fontSize: '13px',
                fontWeight: 'bold',
                whiteSpace: 'normal',
              }}
              disabled={invalid}
              type="submit">
            Valider ma participation
          </Button>
      )
    } else {
      block = (
          <Button
              style={{
                backgroundColor: '#f50082',
                padding: '10px',
                color: 'white',
                fontSize: '13px',
                fontWeight: 'bold',
                whiteSpace: 'normal',
              }}
              disabled={invalid}
              type="submit">
            Valider ma participation
          </Button>
      )
    }
      return (
          <div style={{float: 'right', marginTop: '10px'}}>
              {notBlock}
              {block}
          </div>
      )
  }

  render () {
    const { classes, data: {operation, old_part} } = this.props;
    const { requests } = this.state;
    return (
      <form>
        <h3 style={styles.opTitle}>{this.props.data.operation.title}</h3>
          {this.state.filterOperationLabel.length <= 0 &&
              <Grid container spacing={2}>
                <CircularProgress style={{margin:'auto'}}/>
              </Grid>
          }
          {this.state.filterOperationLabel.length > 0 &&
          <Grid container justify="center">
              {requests.map((request, index) => (
                  <Grid item xs={12} key={index}>
                      <Card>
                          <CardHeader color="info" icon>
                              <CardIcon color="info">
                                  <Queue/>
                              </CardIcon>
                              {old_part === null && <h4 className={classes.cardIconTitle}>Nouvelle demande</h4>}
                          </CardHeader>
                          <CardBody>

                              <Grid container>
                                  <Grid item xs={12} sm={4}>
                                      <img style={styles.opImg}
                                           src={`${process.env.REACT_APP_BACKEND_URL}/media/${operation.image.contentUrl}`}
                                           onError={e => {
                                               e.target.src = `/emptyImg.jpg`
                                           }} alt="..."/>
                                  </Grid>
                                  <Grid item xs={12} sm={8}>
                                      <ol style={styles.ListOPDetail}>
                                          <li style={styles.ListLiOPDetail}>
                                              <Button style={styles.btnOPTranspBig}
                                                      href={`${process.env.REACT_APP_BACKEND_URL}/media/${operation.contract.contentUrl}`}
                                                      type={'button'} rel='noreferrer noopener' target='_blank'>Téléchargez
                                                  et imprimez votre
                                                  mandat</Button>
                                          </li>
                                          <li style={styles.ListLiOPDetail}>
                                              <p style={styles.textListOPDetail}>Remplissez le mandat (date, signature +
                                                  cachet) et scannez-le</p>
                                          </li>
                                      </ol>
                                  </Grid>
                              </Grid>
                          </CardBody>
                      </Card>
                      <Grid container justify="center">
                          <Grid item xs={12}>
                              <FieldGroup
                                  control={this.loginForm}
                                  render={({get, invalid}) => (
                                      <form onSubmit={this.handleSubmit}>
                                          <Grid container spacing={8}>
                                              {this.state.filterOperationLabel.map((item, index) =>
                                                  <Grid item xs={6} sm={6} md={6}>
                                                      {item.labelType === "highlight_photo" &&
                                                      <Paper style={{padding: '10px', marginBottom: '5px'}}>
                                                          <h5 style={style.labelOperationGeneric}>{item.labelName}</h5>
                                                          <UploadGenericHighlightComponent title={'highlight_photo'}
                                                                                           label={item.labelName}
                                                                                           required={item.isRequired}
                                                                                           comments={this.props.comments}/>
                                                          <p style={style.spanOperationGeneric}>(6 Mo maximum, formats
                                                              jpg/png/pdf autorisés)</p>
                                                      </Paper>
                                                      }
                                                      {item.labelType === "sellout_file" &&
                                                      <Paper style={{padding: '10px', marginBottom: '5px'}}>
                                                          <h5 style={style.labelOperationGeneric}>{item.labelName}</h5>
                                                          <UploadGenericSelloutComponent title={'sellout_file'}
                                                                                         label={item.labelName}
                                                                                         required={item.isRequired}
                                                                                         comments={this.props.comments}/>
                                                          <p style={style.spanOperationGeneric}>(6 Mo maximum, formats
                                                              jpg/png/pdf autorisés)</p>
                                                      </Paper>
                                                      }
                                                      {item.labelType === "receipt_file" &&
                                                      <Paper style={{padding: '10px', marginBottom: '5px'}}>
                                                          <h5 style={style.labelOperationGeneric}>{item.labelName}</h5>
                                                          <UploadGenericReceiptComponent title={'receipt_file'}
                                                                                         label={item.labelName}
                                                                                         required={item.isRequired}
                                                                                         comments={this.props.comments}/>
                                                          <p style={style.spanOperationGeneric}>(6 Mo maximum, formats
                                                              jpg/png/pdf autorisés)</p>
                                                      </Paper>
                                                      }
                                                      {item.labelType === "contract_file" &&
                                                      <Paper style={{padding: '10px', marginBottom: '5px'}} >
                                                          <h5 style={style.labelOperationGeneric}>{item.labelName}</h5>
                                                          <UploadGenericReceiptComponent title={'contract_file'}
                                                                                         label={item.labelName}
                                                                                         required={item.isRequired}
                                                                                         comments={this.props.comments}/>
                                                          <p style={style.spanOperationGeneric}>(6 Mo maximum, formats
                                                              jpg/png/pdf autorisés)</p>
                                                      </Paper>
                                                      }
                                                  </Grid>
                                              )}
                                          </Grid>
                                          {this.renderBtn(invalid)}
                                      </form>
                                  )}
                              />
                          </Grid>
                      </Grid>
                  </Grid>
              ))}
          </Grid>
          }
      </form>
    )
  }
}

RequestForm.propTypes =  {
  classes: PropTypes.object.isRequired,
  match_params: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
}

export default compose(withStyles(style), connect(null, { renderSnackbar }))(RequestForm)



// WEBPACK FOOTER //
// ./src/views/Forms/RequestForm.jsx